<div class="container-fluid">
  <h4>{{'Accounts.header' | translate}}</h4>
  <h5>{{'Accounts.subHeader' | translate}}</h5>
  <p>{{'Accounts.shortDescriptionP1' | translate}}</p>
  <p>{{'Accounts.shortDescriptionP2' | translate}}</p>

  <div class="row mt-4">
    <mat-form-field class="col-lg-11 col-md-10 col-sm-9">
      <mat-label>{{'Accounts.lblSelectAccount' | translate}}</mat-label>
      <mat-select name="account">
        @for (account of accounts; track account) {
          <mat-option [value]="account.id" (click)="OnChangeAccount(account.id)">
          {{account.value}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="col-lg-1 col-md-2 col-sm-3 col-12">
      @if (service.currentUser.isReadOnly === false) {
        <button class="matbtnNew" mat-raised-button (click)="OnCreateAccount()"> {{'btnNew' | translate}} </button>
      }
    </div>
  </div>

  @if (isSelected) {
    <div [@slider]="isSelected? 'show' : null" class="slider">
      <div>
        <mat-form-field class="col-12">
          <mat-label>{{'Accounts.lblCode' | translate}}</mat-label>
          <input matInput [(ngModel)]="selectedAccount.code" maxlength="10"/>
        </mat-form-field>
        <mat-form-field class="col-12">
          <mat-label>{{'Accounts.lblOrganisation' | translate}}</mat-label>
          <input matInput [(ngModel)]="selectedAccount.organisation" maxlength="100" />
        </mat-form-field>
        <mat-checkbox style="padding-left: 15px;" color="primary" [(ngModel)]="selectedAccount.enabled">{{'Accounts.ckbxEnabled' | translate}}</mat-checkbox>
      </div>
      <mat-tab-group mat-align-tabs="start" mat-stretch-tabs="false" animationDuration="1000ms">
        <mat-tab label="{{'Accounts.lblUserAccounts' | translate}}">
          @if (service.currentUser.isReadOnly === false) {
            <button mat-raised-button (click)="OnCreateUser()">
              <mat-icon>add</mat-icon> {{'Accounts.lblNewUser' | translate}}
            </button>
          }
          <div class="mat-elevation-z8">
            <div class="search-div">
              <mat-form-field class="search-form-field">
                <input matInput [(ngModel)]="searchKey" placeholder="{{'Accounts.plchldrSearchUser' | translate}}" autocomplete="off"
                  (keyup)="ApplyFilter(0)">
                  @if (searchKey) {
                    <button mat-button matSuffix mat-icon-button aria-label="Clear"
                      (click)="OnSearchClear(0)">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              </div>
              <div class="scrollable">
                <table mat-table [dataSource]="dataSource" matSort>
                  <ng-container matColumnDef="username">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'Accounts.thUsername' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.username}}</td>
                  </ng-container>
                  <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'Accounts.thFirstName' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.firstName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> {{'Accounts.thLastName' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.lastName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;"> {{'Accounts.thEmail' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.email}}</td>
                  </ng-container>
                  <ng-container matColumnDef="phone">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: right;"> {{'Accounts.thPhone' | translate}}</th>
                    <td mat-cell *matCellDef="let element" style="text-align: right;">{{element.phone}}</td>
                  </ng-container>
                  <ng-container matColumnDef="mobile">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: right;"> {{'Accounts.thMobile' | translate}}</th>
                    <td mat-cell *matCellDef="let element" style="text-align: right;">{{element.mobile}}</td>
                  </ng-container>
                  <ng-container matColumnDef="roleName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'Accounts.thRole' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.roleName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="enabled">
                    <th mat-header-cell *matHeaderCellDef style="width: 5%;text-align: center;"> {{'Accounts.thEnabled' | translate}}</th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                      <mat-checkbox color="primary" [disabled]="service.currentUser.isReadOnly === true" [checked]="element.enabled" (change)="OnClickEnabledUser(element)">
                      </mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: center;"> {{'thActions' | translate}} </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                      <button mat-icon-button color="primary" (click)="OnEditUser(element)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      &nbsp;
                      <button mat-icon-button color="warn" (click)="OnDeleteUser(element)">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="loading">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Accounts.tblLoading' | translate}}... </th>
                  </ng-container>
                  <ng-container matColumnDef="noData">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Accounts.tblUserNoData' | translate}}... </th>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                  <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSource!=null}"></tr>
                  <tr mat-footer-row *matFooterRowDef="['noData']"
                  [ngClass]="{'hide':dataSource!=null && userAccountLength != 0}"></tr>
                </table>
              </div>
              <mat-paginator #pgUserAccounts [pageSize]="5" [pageSizeOptions]="[5, 10, 25]" [length]="userAccountLength"></mat-paginator>
            </div>
          </mat-tab>
          <mat-tab label="{{'Accounts.lblServiceAccounts' | translate}}">
            @if (service.currentUser.isReadOnly === false) {
              <button mat-raised-button (click)="OnCreateService()">
                <mat-icon>add</mat-icon> {{'Accounts.lblNewService' | translate}}
              </button>
            }
            <div class="mat-elevation-z8">
              <div class="search-div">
                <mat-form-field class="search-form-field">
                  <input matInput [(ngModel)]="searchKeyService" placeholder="{{'Accounts.plchldrSearchService' | translate}}" autocomplete="off" (keyup)="ApplyFilter(1)">
                  @if (searchKeyService) {
                    <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="OnSearchClear(1)">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              </div>
              <div class="scrollable">
                <table mat-table [dataSource]="dataSourceService">
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef style="width: 20%;">{{'Accounts.thName' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.name}}</td>
                  </ng-container>
                  <ng-container matColumnDef="secret">
                    <th mat-header-cell *matHeaderCellDef style="width: 20%;" header>{{'Accounts.thSecret' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.secret}}</td>
                  </ng-container>
                  <ng-container matColumnDef="key">
                    <th mat-header-cell *matHeaderCellDef style="width: 20%;">{{'Accounts.thKey' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.key}}</td>
                  </ng-container>
                  <ng-container matColumnDef="notes">
                    <th mat-header-cell *matHeaderCellDef>{{'Accounts.thNotes' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.notes}}</td>
                  </ng-container>
                  <ng-container matColumnDef="enabled">
                    <th mat-header-cell *matHeaderCellDef style="width: 5%;text-align: center;"> {{'Accounts.thEnabled' | translate}}</th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                      <mat-checkbox color="primary" [disabled]="service.currentUser.isReadOnly === true" [checked]="element.enabled" (change)="OnClickEnabledService(element)"></mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: center;"> {{'thActions' | translate}} </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                      <button mat-icon-button color="primary" (click)="OnEditService(element)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      &nbsp;
                      <button mat-icon-button color="warn" (click)="OnDeleteService(element)">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="loading">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Accounts.tblLoading' | translate}}... </th>
                  </ng-container>
                  <ng-container matColumnDef="noData">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Accounts.tblServiceNoData' | translate}}... </th>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayColumnsService; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayColumnsService;"></tr>
                  <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceService!=null}"></tr>
                  <tr mat-footer-row *matFooterRowDef="['noData']"
                  [ngClass]="{'hide':dataSourceService!=null && serviceAccountLength != 0}"></tr>
                </table>
              </div>
              <mat-paginator #pgServiceAccounts [pageSize]="5" [pageSizeOptions]="[5, 10, 25]" [length]="serviceAccountLength"></mat-paginator>
            </div>
          </mat-tab>
        </mat-tab-group>
        @if (service.currentUser.isReadOnly === false) {
          <div class="mt-2">
            <button mat-raised-button style="float: right; margin-left: 10px;" color="primary" type="button" (click)="OnSaveClick()">{{'btnSave' | translate}}</button>
            <button [disabled]="service.currentUser.userRole === operatorRoleName" mat-raised-button style="float: right;" color="secondary" type="button" (click)="OnDeleteClick()">{{'btnDelete' | translate}}</button>
          </div>
        }
      </div>
    }
  </div>
